module.exports = __webpack_public_path__ + "img/Svensk-barter-ide-diagram.ff946a20.png";